import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { fontRobotoCondensed, setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { ContentItemHomeAdvertiserV2 } from "scmp-app/components/content/content-item-render/variants/home-advertiser-v2";

import ArrowNext from "./arrow-next.svg";

export const StyledContentItemHomeAdvertiserV2 = styled(ContentItemHomeAdvertiserV2)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;

  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const Title = styled.div`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const SwiperContainer = styled.div`
  inline-size: 100%;
`;

export const SwiperWrapper = styled.div`
  position: relative;

  overflow: visible;

  &:hover {
    .card-swiper-button-prev svg,
    .card-swiper-button-next svg {
      opacity: 1;
    }
  }

  .card-swiper-button-prev svg,
  .card-swiper-button-next svg {
    opacity: 0;

    transition: opacity 1s;
  }

  .card-swiper-button-disabled {
    opacity: 0;
  }
`;

export const StyledSwiper = styled(Swiper)`
  block-size: auto;

  overflow-y: hidden;

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }

  .swiper-wrapper {
    inline-size: fit-content;
  }

  .swiper-slide {
    block-size: auto;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  max-inline-size: 216px;
`;

const ArrowStyle = css`
  inset-block-start: 50%;

  display: none;

  ${theme.breakpoints.up("tablet")} {
    position: absolute;
    z-index: 1;

    display: block;

    cursor: pointer;
  }
`;

export const StyledArrowNext = styled(ArrowNext)`
  ${ArrowStyle}
  transform: translateY(-50%);
  ${theme.breakpoints.up("tablet")} {
    inset-inline-end: -8px;
  }
`;

export const StyledArrowPrevious = styled(ArrowNext)`
  ${ArrowStyle}
  transform: translateY(-50%) rotate(180deg);
  ${theme.breakpoints.up("tablet")} {
    inset-inline-start: -8px;
  }
`;
